__turbopack_context__.v({
  "textButton--login": "styles-module__UAZmxq__textButton--login",
  "textButton--signup": "styles-module__UAZmxq__textButton--signup",
});
